var _style, _defs, _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 139 113",
    viewBox: "0 0 139 113",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000053504646934646330740000009134454895836103350_);}\n\t.st1{fill:#fff;}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 139,
    height: 113
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m124.1 0h14.6l-59.2 67.6c-1.5 1.7-1.6 4.3-0.1 6.1l34.1 39.7h-15.2l-31.5-36.8-1.6-2c-1.5-1.7-1.4-4.4 0.1-6.1l58.8-68.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m91.2 73.7c-1-1.1-1.3-2.7-1-4.1 0.3-0.8 0.8-1.6 1.4-2.2l3.9-4.3 43.5 50.3h-13.8s-25.5-29.8-34-39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.2,113.4H0l46.6-53.9c1.5-1.7,1.5-4.3,0-6L0.4,0H15l46.5,53.9c1.2,1.6,1.4,3.9,0.1,5.4    C49.4,73.4,15.2,113.4,15.2,113.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m40.6 0h-14l43.1 49.9s0.1-0.1 4.9-5.8c1.3-1.5 1.6-3.4 0.1-4.9-9-9.2-34.1-39.2-34.1-39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m82.6 34.8 29.9-34.8h-14.2l-15.6 18.2-4.5 5.3c-1.5 1.7-1.6 4.3-0.1 6.1 1.1 1.3 4.5 5.2 4.5 5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m56.6 78.6-29.9 34.8h14.1l15.6-18.2 4.5-5.3c1.5-1.7 1.6-4.3 0.1-6.1-1.1-1.3-4.4-5.2-4.4-5.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImx);
export default __webpack_public_path__ + "static/media/imx.be40b749786bef3e51499acd99a3f309.svg";
export { ForwardRef as ReactComponent };